const schema = [
        ['name'],
        ['description'],
];

export default schema;
